import { trackingGAevent, uniformData } from '@utils/gtm'
import { CollezioneItemType } from '../../../utils/types'
import CardCollezione from '../CardCollezione/CardCollezione'
import styles from './CardCollezioneList.module.sass'

interface Props {
  items: CollezioneItemType['colori'] | CollezioneItemType['decori']
  className?: string
  variant?: 'colori' | 'decori'
}

const CardCollezioneList = (props: Props) => {
  const { items = [], className = '', variant = 'colori' } = props

  const subItem = variant === 'colori' ? 'tonalita' : 'decori'

  const handleClickTrackingColore = (coloreUrl) => {
    const colore = coloreUrl ? coloreUrl.slice(coloreUrl.lastIndexOf('/') + 1) : ''
    trackingGAevent('click_colore', {
      type: uniformData(colore),
    })
  }

  return items?.length ? (
    <div className={`${styles.root} ${className}`}>
      <div className={`${styles.layout}`}>
        {items.length > 0 &&
          items.map((item) => (
            <div key={item.pk} className={styles.item}>
              {(item.nome || item.categoria) && (
                <h3
                  className={styles.title}
                  dangerouslySetInnerHTML={{ __html: item.nome || item.categoria }}
                />
              )}
              <div className={styles.itemContent}>
                {item[subItem].length > 0 &&
                  item[subItem].map((card) => (
                    <CardCollezione
                      item={card}
                      key={card.pk}
                      variant={variant}
                      className={styles.card}
                      onClickColore={handleClickTrackingColore}
                    />
                  ))}
              </div>
            </div>
          ))}
      </div>
    </div>
  ) : (
    <></>
  )
}

export default CardCollezioneList
